import React from 'react';
import { func } from '../helpers';
import * as rdd from 'react-device-detect';
import { Globe } from 'components';

const Footer = (props) => {

    const [root, setRoot] = React.useState('');
    const [globe, setGlobe] = React.useState(false);
    const [isMobile, setIsMobile] = React.useState(false);

    React.useEffect(() => {
        setRoot(window.location.pathname.replace('/', ''));
        setIsMobile(rdd.isMobile);
    }, []);

    return (
        <React.Fragment>
            {!root.includes('tl/') && !root.includes('scanner/') && (
            <footer className="pt-50s pb-20 bg-grey">
                <div className="container">
                    <div className={`footer-copy-right pt-30 mt-20 wow fadeInUp animated ${isMobile ? 'text-center' : ''}`}>
                        <div className="row">
                            <div className={`col-lg-4 ${isMobile ? 'mb-15' : ''}`}>
                                <p className="float-md-lefts font-small text-muted m-0">
                                    FayaVotes - Your 360° e-voting & e-tickets platform • v.{func.app.version}
                                </p>
                            </div>

                            <div className={`col-lg-4 text-center ${isMobile ? 'mb-15' : ''}`}>
                                <ul className="header-social-network d-inline-block list-inline color-white mb-0">
                                    <li className="list-inline-item">
                                        <a className="fb" href="https://facebook.com/fayavotes" target="_blank" title="Facebook">
                                            <i className="elegant-icon social_facebook"></i>
                                        </a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a className="ig" href="https://instagram.com/faya_votes" target="_blank" title="Tweet now">
                                            <i className="elegant-icon social_instagram"></i>
                                        </a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a className="in" href="https://linkedin.com/company/fayavotes" target="_blank" title="Pin it">
                                            <i className="elegant-icon social_linkedin"></i>
                                        </a>
                                    </li>
                                    {process.env.space !== 'production' && (
                                        <li className="list-inline-item" onClick={() => setGlobe(true)}>
                                            <a className="ins" style={{ background: '#202020' }}><i className="fa fa-globe"></i></a>
                                        </li>
                                    )}
                                </ul>
                            </div>

                            <div className="col-lg-4">
                                <p className={`float-md-rights font-small text-muteds m-0`}>
                                    ©{func.dates.yr}, <a className="text-primary" href="https://anchoratechs.com" target="_blank">Anchora Technologies Ltd</a> • All rights reserved
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            )}

            <Globe
                visible={globe}
                onCancel={() => {
                    setGlobe(false);
                }}
            />
        </React.Fragment>
    );
}


export default Footer;